import { Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from './translate.service';

@Pipe({
  name: 'uexTranslate'
})
export class TranslatePipe implements PipeTransform {
  constructor(
    private _translateService: TranslateService
  ) { }

  transform(path: string): string {
    return this._translateService.get(path);
  }
}

@Pipe({
  name: 'uexTranslateImpure',
  pure: false
})
export class TranslateImpurePipe implements PipeTransform {
  constructor(
    private _translateService: TranslateService
  ) { }

  transform(path: string): string {
    return this._translateService.get(path);
  }
}
